// import { useMutation } from "@tanstack/react-query";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { createUser as createUserApi } from "services/apiAuth";

// export function useSignUp() {
//   const navigate = useNavigate();

//   const { mutate: createUser, isLoading: isCreating } = useMutation({
//     mutationFn: createUserApi,
//     onSuccess: () => {
//       toast.success("New merchant successfully created");
//       navigate("/login");
//     },
//     onError: (error) => {
//       toast.error(error.message || "Failed to register merchant");
//     },
//   });

//   return { isCreating, createUser };
// }
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createUser as createUserApi } from "services/apiAuth";

export function useSignUp() {
  const [isCreating, setIsCreating] = useState(false);
  const navigate = useNavigate();

  const createUser = async (payload) => {
    try {
      setIsCreating(true);

      await createUserApi(payload);

      toast.success("New merchant successfully created");
      navigate("/login");
    } catch (error) {
      console.error("Error during sign-up:", error);
      toast.error(error.message || "Failed to register merchant");
    } finally {
      setIsCreating(false);
    }
  };

  return { isCreating, createUser };
}
